import * as actionTypes from "../constants";

let initialState = {
  user: {},
  loading: false,
  error: null
}


const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AUTH_REQUEST_START:
      return {
        ...state,
        loading: true
      }

    case actionTypes.AUTH_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false
      }

    case actionTypes.AUTH_REQUEST_FAIL:
      return {
        ...state,
        error: { ...action.error },
        loading: false
      }

    case actionTypes.AUTH_USER_REQUEST_SUCCESS:
      return {
        ...state,
        user: { ...action.user },
        loading: false,
        error: null
      }

    case actionTypes.AUTH_LOGOUT_REQUEST_SUCCESS:
      return {
        ...state,
        user: {},
        loading: false,
        error: null
      }

    case actionTypes.AUTH_CLEAR_ERROR:
      return {
        ...state,
        error: null
      }

    case actionTypes.AUTH_TOKEN_REFRESH_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null
      }

    default: return state;
  }
}

export default reducer;